// Adapted from davinci-elections apps/web/src/theme/Theme.tsx @ 6e23f58
import { ChakraProvider } from '@chakra-ui/react'
import type { PropsWithChildren } from 'react'
import { ColorModeProvider } from './color-mode'
import { getAppSystem } from './system'

import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'

// Mirrors vocdoni-app src/theme/Theme.tsx. The accent color is build-time config here
// (VITE_PRIMARY_COLOR, any #rgb/#rrggbb); unset ⇒ the stock black accent.
const PRIMARY_COLOR = import.meta.env.VITE_PRIMARY_COLOR as string | undefined

export const Theme = ({ children }: PropsWithChildren) => (
  <ColorModeProvider>
    <ChakraProvider value={getAppSystem(PRIMARY_COLOR)}>{children}</ChakraProvider>
  </ColorModeProvider>
)
